module.exports = __webpack_public_path__ + "img/logo-black-express.5a6cc48.png";